"use strict";
import Api from "../api/api";
import DisablingButton from "../components/disabling_button";
import LinkedStateMixin from "react-addons-linked-state-mixin";
export default React.createClass({
  mixins: [LinkedStateMixin],
  getInitialState: function() {
    return {
      selectedOption: this.props.documentBatch.duplicateInvoice ? "duplicate-invoice" : "ignore"
    };
  },
  handleOptionChange: function(changeEvent) {
    this.setState({
      selectedOption: changeEvent.target.value
    });
  },
  render: function() {
    const duplicateInvoice = this.props.documentBatch.duplicateInvoice;
    const duplicateInvoiceText = duplicateInvoice ? `Duplicate of Invoice ${duplicateInvoice.number} for $${parseFloat(duplicateInvoice.source_invoice_amount).toFixed(2)} from ${duplicateInvoice.carrier_name}` : "";
    return /* @__PURE__ */ React.createElement("div", { className: "modal__medium-container reply__mark-complete" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("h3", null, "Ignore All Groups")), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("p", null, "This step will remove the email from the New or Replies queue. Exceptions, however, will remain in the Exceptions or Waiting queue.")), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("h6", null, "Reason"), duplicateInvoice && /* @__PURE__ */ React.createElement("div", { className: "row ignore-entry-view__radio-option" }, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "radio",
        checked: this.state.selectedOption == "duplicate-invoice",
        onChange: this.handleOptionChange,
        id: "duplicate-invoice",
        value: "duplicate-invoice"
      }
    ), /* @__PURE__ */ React.createElement("label", { htmlFor: "duplicate-invoice" }, duplicateInvoiceText)), /* @__PURE__ */ React.createElement("div", { className: "row ignore-entry-view__radio-option" }, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "radio",
        checked: this.state.selectedOption == "ignore",
        onChange: this.handleOptionChange,
        id: "ignore",
        value: "ignore"
      }
    ), /* @__PURE__ */ React.createElement("label", { htmlFor: "ignore" }, "Other"))), this.state.selectedOption == "ignore" && /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement(
      "textarea",
      {
        valueLink: this.linkState("reason")
      }
    )), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        disabled: this.state.completing,
        disabledText: "Ignoring...",
        onClick: this.ignoreEntry,
        className: "button--confirmation"
      },
      "Ignore All Groups"
    ), " \xA0", /* @__PURE__ */ React.createElement("span", { className: "button--cancel-wrapper" }, "or", /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "button--cancel",
        onClick: this.props.onCancel
      },
      "cancel"
    )))));
  },
  ignoreEntry: function() {
    this.setState({ completing: true });
    if (this.state.selectedOption == "ignore") {
      Api.DocumentBatches.ignore(this.props.documentBatch.id, this.state.reason).then(() => {
        this.setState({ completing: false });
        this.props.ignoreEntryComplete();
      }, _.identity);
    } else {
      Api.DocumentBatches.ignoreAsDuplicate(this.props.documentBatch.id, this.props.documentBatch.duplicateInvoice.id).then(() => {
        this.setState({ completing: false });
        this.props.ignoreEntryComplete();
      }, _.identity);
    }
  }
});
